import React from 'react'

export const ClippedWrapper: React.FC<{clipPathId: string}> = ({clipPathId, children}) => (
  <g clipPath={`url(#${clipPathId})`}>{children}</g>
)
